export default {
  'app.setting.pagestyle': 'Configuração de estilo da página',
  'app.setting.pagestyle.dark': 'Estilo escuro',
  'app.setting.pagestyle.light': 'Estilo claro',
  'app.setting.content-width': 'Largura do Conteúdo',
  'app.setting.content-width.fixed': 'Fixo',
  'app.setting.content-width.fluid': 'Fluido',
  'app.setting.themecolor': 'Cor do Tema',
  'app.setting.themecolor.dust': 'Vermelho Poeira',
  'app.setting.themecolor.volcano': 'Vulcão',
  'app.setting.themecolor.sunset': 'Laranja Pôr do sol',
  'app.setting.themecolor.cyan': 'Ciano',
  'app.setting.themecolor.green': 'Verde Polar',
  'app.setting.themecolor.daybreak': 'Azul Amanhecer (padrão)',
  'app.setting.themecolor.geekblue': 'Azul Geek',
  'app.setting.themecolor.purple': 'Roxo Dourado',
  'app.setting.navigationmode': 'Modo de Navegação',
  'app.setting.sidemenu': 'Layout de Menu Lateral',
  'app.setting.topmenu': 'Layout de Menu Superior',
  'app.setting.fixedheader': 'Cabeçalho Fixo',
  'app.setting.fixedsidebar': 'Barra Lateral Fixa',
  'app.setting.fixedsidebar.hint': 'Funciona no Layout de Menu Lateral',
  'app.setting.hideheader': 'Ocultar Cabeçalho ao rolar',
  'app.setting.hideheader.hint': 'Funciona quando Ocultar Cabeçalho está habilitado',
  'app.setting.othersettings': 'Outras Configurações',
  'app.setting.weakmode': 'Modo Amigável para Daltônicos',
  'app.setting.copy': 'Copiar Configuração',
  'app.setting.copyinfo':
    'cópia bem-sucedida, substitua defaultSettings em src/models/setting.js',
  'app.setting.production.hint':
    'O painel de configurações aparece apenas no ambiente de desenvolvimento, modifique manualmente',
};